var exports = {
  "Y": "StandaloneFaq__3H5T7V",
};

module.exports = exports;
